import { render, staticRenderFns } from "./GMBManagerPage.vue?vue&type=template&id=2f6af4b8&"
import script from "./GMBManagerPage.vue?vue&type=script&lang=js&"
export * from "./GMBManagerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f6af4b8')) {
      api.createRecord('2f6af4b8', component.options)
    } else {
      api.reload('2f6af4b8', component.options)
    }
    module.hot.accept("./GMBManagerPage.vue?vue&type=template&id=2f6af4b8&", function () {
      api.rerender('2f6af4b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/GMBManagerPage.vue"
export default component.exports